import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {LeafType, isBenchlingTypeDefList} from 'data-types/benchling-type-def/BenchlingTypeDef';
import ProcessManagementSearchInput, {
  ProcessManagementSearchInputProps,
} from 'processes/ProcessManagementSearchInput';
import {Filter, FilterKey, keyToEmptyFilter} from 'search/SearchConstants';
import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';

import {ValueInputProps} from './ValueInputTypes';
import valueToItemsArray, {itemsToValuesArray} from './valuesToItemsArray';

function ProcessManagementValueInput({
  allowAutoFocus,
  onChange,
  typeDef,
  valueInput,
  schemaId,
  selectedType,
  disabled,
}: ValueInputProps<LeafType.PROCESS | LeafType.PROCESS_TASK> &
  Pick<ProcessManagementSearchInputProps, 'selectedType'>): JSX.Element {
  const value = valueInput.isValid ? valueInput.value : null;
  const processTaskSchemaFilter: Filter | null =
    schemaId != null
      ? {
          ...keyToEmptyFilter(FilterKey.SCHEMA),
          value: [schemaId],
        }
      : null;

  function handleOnChange(items: Array<Item>): void {
    const itemIds = itemsToValuesArray(items);

    if (isBenchlingTypeDefList(typeDef)) {
      onChange(itemIds);
    } else {
      onChange(itemIds[0] ?? null);
    }
  }

  return (
    <ProcessManagementSearchInput
      shouldAllowMultiple={allowAutoFocus}
      onChange={handleOnChange}
      selectedItems={valueToItemsArray(value)}
      selectedType={selectedType}
      extraFilters={processTaskSchemaFilter ? [processTaskSchemaFilter] : undefined}
      disabled={disabled}
      isReadOnly={disabled} // TODO(BNCH-57668): keep disabled and isReadOnly separate when behavior is fixed
    />
  );
}

/**
 * @package
 */
export function ProcessValueInput(props: ValueInputProps<LeafType.PROCESS>): JSX.Element {
  return <ProcessManagementValueInput {...props} selectedType={ModelTypeConstants.PROCESS} />;
}

/**
 * @package
 */
export function ProcessTaskValueInput(props: ValueInputProps<LeafType.PROCESS_TASK>): JSX.Element {
  return <ProcessManagementValueInput {...props} selectedType={ModelTypeConstants.PROCESS_TASK} />;
}
